import { Directive } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { FormUtil } from '../utils';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[attachToForm]',
	providers: [
		{
			provide: ControlContainer,
			useFactory: FormUtil.getForm,
			deps: [NgForm],
		},
	],
})
export class AttachToFormDirective {}
